var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1128.88 1128.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "fil0",
    points: "389.73,351.75 574.23,536.26 763.86,346.62 800.49,383.24 610.85,572.88 800.48,762.51 763.86,799.13 574.23,609.5 384.6,799.13 347.98,762.51 537.61,572.88 347.98,383.24 384.6,346.62 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M564.44 0.01c311.73,0 564.44,252.71 564.44,564.44 0,311.73 -252.71,564.44 -564.44,564.44 -311.73,0 -564.44,-252.71 -564.44,-564.44 0,-311.73 252.71,-564.44 564.44,-564.44zm0 40.79c289.2,0 523.65,234.45 523.65,523.65 0,289.2 -234.45,523.65 -523.65,523.65 -289.2,0 -523.65,-234.45 -523.65,-523.65 0,-289.2 234.45,-523.65 523.65,-523.65z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose2);
export default __webpack_public_path__ + "static/media/close2.c6c59de22fcb4584976980f8ce6167cd.svg";
export { ForwardRef as ReactComponent };